import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";

import favicon from "../../../assets/mainItems/favicon.png";
import franchisePdf from "../../../assets/mainItems/FranchiseOpportunityItaliaPizza&Pasta.pdf";
import ButtonFormat from "../../shared/ButtonFormat/ButtonFormat";
import "./Navbar.css";
import WebplaceContext from "../../../store/webplace-context";

const Navbar = ({ couponStatus }) => {
  const navbarCtx = useContext(WebplaceContext).navbarItems;
  const stylesCtx = useContext(WebplaceContext).navbarItems.navbar_styles;
  let logoSize;

  const [hamburgerStatus, setHamburgerStatus] = useState(false);
  const [showFranchiseModal, setShowFranchiseModal] = useState(false);
  
  // Open and close hamburger
  const mobileHamburgerHandler = () => {
    setHamburgerStatus(!hamburgerStatus);
  };

  // Close hamburger if element is clicked
  const mobileHamburgerOptionHandler = () => {
    if (hamburgerStatus) {
      setHamburgerStatus(false);
    }
  };

  // Handle franchise modal open
  const handleFranchiseModalOpen = () => {
    setShowFranchiseModal(true);
    document.body.classList.add('modal-open');
    mobileHamburgerOptionHandler(); // Close mobile menu if open
  };

  // Handle franchise modal close
  const handleFranchiseModalClose = () => {
    setShowFranchiseModal(false);
    document.body.classList.remove('modal-open');
  };

  // Handle keyboard navigation for hamburger menu
  const handleHamburgerKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      mobileHamburgerHandler();
    }
  };

  // Handle keyboard navigation for franchise button
  const handleFranchiseKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleFranchiseModalOpen();
    }
  };

  // Handle escape key to close modal
  const handleModalKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleFranchiseModalClose();
    }
  };

  // Handle backdrop click to close modal
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      handleFranchiseModalClose();
    }
  };

  if (navbarCtx.logo_size === "large") {
    logoSize = "nav-fav-large";
  } else if (navbarCtx.logo_size === "medium") {
    logoSize = "nav-fav-medium";
  } else {
    logoSize = "nav-fav-small";
  }

  const redirectionStatus = (url) => {
    let redirection;
    // eslint-disable-next-line
    if (url.startsWith("/")) {
      redirection = "_self";
    } else {
      redirection = "_self";
    }
    return redirection;
  };

  const menuItems = (
    <>
      {navbarCtx.options.map((navitem) => {
        return (
          <NavLink
            key={navitem.title}
            className={navitem.shown ? "menu-items" : "menu-disable"}
            style={{ color: stylesCtx.font_color }}
            to={navitem.url}
            target={redirectionStatus(navitem.url)}
            onClick={mobileHamburgerOptionHandler}
            aria-label={`Navigate to ${navitem.title}`}
            tabIndex={navitem.shown ? 0 : -1}
          >
            {navitem.shown && navitem.title}
          </NavLink>
        );
      })}
      <button
        className="menu-items franchise-opportunity-btn"
        style={{ 
          color: stylesCtx.font_color,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontFamily: 'inherit',
          fontSize: '17px',
          fontWeight: '600',
          textTransform: 'capitalize'
        }}
        onClick={handleFranchiseModalOpen}
        onKeyDown={handleFranchiseKeyDown}
        aria-label="Open Franchise Opportunity PDF document"
        title="View Franchise Opportunity Information"
        tabIndex={0}
      >
        Franchise Opportunity
      </button>
      <div className="btn-style-navbar">
        <ButtonFormat
          btnSize={stylesCtx.navbar_btn.btn_size}
          showArrow={stylesCtx.navbar_btn.show_arrow}
          arrowAtStart={stylesCtx.navbar_btn.arrow_at_start}
          arrowColor={stylesCtx.navbar_btn.arrow_color}
          showBorder={stylesCtx.navbar_btn.show_border}
          borderColor={stylesCtx.navbar_btn.border_color}
          backgroundColor={stylesCtx.navbar_btn.background_color}
          fontColor={stylesCtx.navbar_btn.font_color}
          capitalizeText={stylesCtx.navbar_btn.capitalize_text}
          btnText={navbarCtx.main_button_text}
          url={navbarCtx.main_button_redirect}
        />
      </div>
    </>
  );

  return (
    <>
      <header
        className="navbar-component-container"
        style={{ backgroundColor: stylesCtx.background_color }}
        role="banner"
        aria-label="Main navigation"
      >
        <div className="navbar-logo">
          <NavLink to={"/"} aria-label={`Go to ${navbarCtx.business_name} homepage`}>
            {navbarCtx.logo_exists ? (
              <img
                src={favicon}
                className={`navbar-fav-image ${logoSize}`}
                alt={`${navbarCtx.business_name} logo`}
                tabIndex="0"
              />
            ) : (
              <div
                className="navbar-fav-title"
                style={{ color: stylesCtx.font_color }}
              >
                {navbarCtx.business_name}
              </div>
            )}
          </NavLink>
        </div>
        <nav 
          role="navigation" 
          aria-label="Main menu"
        >
          <div className="nav-container">
            <div className="menu" role="menubar" aria-label="Navigation menu">
              {menuItems}
            </div>
            <button
              className={
                hamburgerStatus ? "hamburger active-hamburger" : "hamburger"
              }
              onClick={mobileHamburgerHandler}
              onKeyDown={handleHamburgerKeyDown}
              aria-expanded={hamburgerStatus}
              aria-controls="mobile-menu"
              aria-label={hamburgerStatus ? "Close navigation menu" : "Open navigation menu"}
              aria-haspopup="true"
              tabIndex={0}
            >
              <span style={{ backgroundColor: stylesCtx.font_color }} aria-hidden="true"></span>
              <span style={{ backgroundColor: stylesCtx.font_color }} aria-hidden="true"></span>
              <span style={{ backgroundColor: stylesCtx.font_color }} aria-hidden="true"></span>
            </button>
          </div>
        </nav>
        <div
          id="mobile-menu"
          className={`${hamburgerStatus ? "active-dropdown" : "inactive-dropdown"}`}
          role="region"
          aria-label="Mobile navigation menu"
          aria-hidden={!hamburgerStatus}
        >
          <div
            className={`nav-dropdown ${couponStatus ? "coupon-navbar" : ""}`}
            style={{ backgroundColor: stylesCtx.navbar_mobile_dropdown }}
          >
            {menuItems}
          </div>
        </div>
      </header>

      {/* Franchise Opportunity Modal */}
      {showFranchiseModal && (
        <div 
          className="franchise-modal-overlay"
          onClick={handleBackdropClick}
          onKeyDown={handleModalKeyDown}
          role="dialog"
          aria-modal="true"
          aria-labelledby="franchise-modal-title"
          aria-describedby="franchise-modal-description"
        >
          <div className="franchise-modal-content">
            <div className="franchise-modal-header">
              <h2 id="franchise-modal-title">Franchise Opportunity</h2>
              <button
                className="franchise-modal-close"
                onClick={handleFranchiseModalClose}
                aria-label="Close franchise opportunity modal"
                tabIndex={0}
              >
              </button>
            </div>
            <div id="franchise-modal-description" className="franchise-modal-body">
              <iframe
                src={franchisePdf}
                title="Franchise Opportunity PDF"
                width="100%"
                height="600px"
                style={{ border: 'none' }}
                tabIndex={0}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
